import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowLeft, BookOpen } from 'lucide-react';

export default function JackalOFNR() {
  const navigate = useNavigate();

  const jackalStatements = [
    { id: 1, statement: 'Mom always favors you.' },
    { id: 2, statement: 'Your life is such a mess.' },
    { id: 3, statement: 'You are so self centered.' },
    { id: 4, statement: 'I can\'t count on you for anything.' },
    { id: 5, statement: 'Stop bragging so much.' },
    { id: 6, statement: 'Why do you always talk to your friends about our relationship?' },
    { id: 7, statement: 'Do you care about anything besides money?' },
    { id: 8, statement: 'You\'re going on vacation again without me?' },
    { id: 9, statement: 'You\'re such a slob; you always make a mess.' },
    { id: 10, statement: 'Stop whining; grow up.' },
    { id: 11, statement: 'Can\'t you just listen to me for once?' },
    { id: 12, statement: 'You don\'t understand anything about me, do you.' },
    { id: 13, statement: 'You\'re always bossing me around.' },
    { id: 14, statement: 'You always dominate our conversations.' },
    { id: 15, statement: 'Why do I always have to do everything around here?' },
    { id: 16, statement: 'You always make my job so hard.' },
    { id: 17, statement: 'You don\'t understand anything about me, do you.' },
    { id: 18, statement: 'Why do you text me so much?' },
    { id: 19, statement: 'All you ever do is complain.' },
    { id: 20, statement: 'Talking to you is like talking to a wall.' },
    { id: 21, statement: 'If everybody did as little as you, this company would go out of business.' },
    { id: 22, statement: 'With how little you try, you expect to pass this class?' },
    { id: 23, statement: 'How come I only hear from you when you need something?' },
    { id: 24, statement: 'Stop hovering! Give me some space.' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="border-b border-slate-700/50 bg-slate-900/90 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button onClick={() => navigate('/belonging-ebook')} variant="outline" size="sm" className="border-slate-600 hover:border-slate-500 text-white hover:bg-slate-800">
                <ArrowLeft className="h-4 w-4 mr-2" />Back to Guide
              </Button>
              <div>
                <h1 className="text-2xl font-bold text-white">Jackal Statements for OFNR Practice</h1>
              </div>
            </div>
            <div className="flex items-center gap-2 text-slate-400 text-sm"><BookOpen className="h-4 w-4" /><span>Page 87</span></div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-6 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="bg-purple-900/20 border border-purple-700/30 rounded-lg p-6 mb-8">
            <p className="text-purple-100 leading-relaxed mb-4">
              This is a list of jackal statements that could be used for practicing creating <span className="font-semibold">Honesty OFNR statements</span> and <span className="font-semibold">Empathy OFNR statements</span>.
            </p>
            <div className="bg-purple-900/30 rounded p-4">
              <p className="text-purple-200 font-semibold mb-2">Example #1: "Mom always favors you."</p>
              <p className="text-green-100 text-sm mb-2"><span className="font-semibold">Honesty OFNR:</span> Hearing you say that (observation), I feel frustrated and annoyed (feelings) because that really doesn't meet my need for understanding and shared reality (needs). Would you be willing to sit down with me and Mom to talk about this together? (request)</p>
              <p className="text-blue-100 text-sm"><span className="font-semibold">Empathy OFNR:</span> Hearing you say that (observation), I'm wondering if you're feeling hurt and sad (feelings) because you have needs for consideration and closeness (needs). Is that what's going on for you? (request)</p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {jackalStatements.map((item) => (
              <div key={item.id} className="bg-slate-800/40 border border-slate-700/50 rounded-lg p-4 hover:bg-slate-800/60 transition-colors">
                <div className="flex items-start gap-3">
                  <span className="text-slate-500 font-mono text-sm mt-1">{item.id}</span>
                  <p className="text-slate-100">"{item.statement}"</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
